import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const TuningSelector: React.FC = () => {
  const tuningId = useFretboardConfigStore((state) => state.tuningId);
  const setTuningId = useFretboardConfigStore((state) => state.setTuningId);
  const instrumentDefinition = useFretboardConfigStore((state) => {
    return state.fretboardModel.getInstrumentDefinition();
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTuningId(e.target.value);
  };

  const availableTunings = instrumentDefinition?.defaultTunings || [];

  return (
    <div className="form-control w-full mb-2">
      <label className="label">
        <span className="label-text">Tuning</span>
      </label>
      <select className="select select-bordered w-full" value={tuningId} onChange={handleChange}>
        {availableTunings.map((tuning) => (
          <option key={tuning.id} value={tuning.id}>
            {tuning.label}
          </option>
        ))}
      </select>
    </div>
  );
};
